/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useRef, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import cookies from "js-cookie";
import _ from "lodash";
import { GetServerSideProps, GetServerSidePropsContext } from "next";
import Link from "next/link";
import router from "next/router";
import ReactPlayer from "react-player/lazy";
import { useQuery } from "react-query";
import { Carousel } from "react-responsive-carousel";
import { useUpdateEffect } from "react-use";
import { Button } from "components/button";
import { CustomModal } from "components/custom-modal";
import { SchoolFilterSelect } from "components/select";
import { AppContainer } from "container/app-container";
import { FeaturedSchools } from "container/landing-page";
import { NonDashboardWrapper } from "container/non-dashboard-wrapper";
import SingleSchoolBanner from "container/school-profile/new-banner";
import {
   SchoolApplicationForm,
   SchoolEnquiryForm,
} from "container/school-profile/school-application";
import {
   AddNewReview,
   NewSchoolComments,
} from "container/school-profile/school-comments/new-school-comment";
import { SchoolRatings } from "container/school-profile/school-ratings";
import { fetchAllRankedAds } from "services/adverts";
import { getSingleSchool, getSingleSchoolClient } from "services/school";
import {
   AdvertDiv,
   DetailsFlexDiv,
   NewSchoolContainer,
   ReviewDiv,
   VideosWrapper,
} from "styles/single-school/single-school.style";
import { getSession } from "utils/auth";
import { CountriesList } from "utils/countries-list";
// import { statesWithLGA } from "utils/countryList";
import { paramsObjectToQueryString, isClient } from "utils/generic-utils";
import { schoolCategory, schoolFees, schoolType } from "utils/schoolFormOptions";

const SingleSchool = ({ schoolData, slug, adverts, query }) => {
   const [currentTab, setCurrentTab] = useState(
      query?.admission
         ? "admission"
         : query?.programmes
         ? "programmes"
         : query?.contact
         ? "address"
         : "overview"
   );
   const commentRef = useRef<HTMLDivElement | any>();
   const [_isPlaying, setIsPlaying] = useState(false);
   const [modalVisibility, setModalVisibility] = useState(!!query?.apply);
   const [isPaymentSuccessful, setIsPaymentSuccessful] = useState(false);
   const [enquiryModalVisibility, setEnquiryModalVisibility] = useState(!!query?.enquiry);
   const [currentFilters, setCurrentFilter] = useState({});
   const [currentStates, setCurrentStates] = useState<any[]>([]);
   const [schoolReviews, setSchoolsReviews] = useState([]);
   // const [_lgas, setLgas] = useState([]);
   const [_txRef, setTxRef] = useState<any>(null);
   const { inSession } = getSession();

   useUpdateEffect(() => {
      setCurrentTab("overview");
   }, [isClient && router.pathname]);

   useEffect(() => {
      if (router.isReady) {
         const { trxref, success } = router.query;

         if (!!success) {
            setIsPaymentSuccessful(true);
            setTxRef(trxref);
         }
      }
   }, []);

   const open = () => setModalVisibility(true);
   const close = () => setModalVisibility(false);

   const handleCloseSuccessModal = () => setIsPaymentSuccessful(false);

   const openEnquiryModal = () => setEnquiryModalVisibility(true);
   const closeEnquiryModal = () => setEnquiryModalVisibility(false);

   const { data, refetch } = useQuery(["single-school", slug], () => getSingleSchoolClient(slug), {
      initialData: schoolData,
   });

   const { school, similarSchools, ratings, sisterSchools, likes, views } = data?.data?.data;

   const variant = {
      hidden: { x: 0, opacity: 0, y: -4 },
      show: {
         x: 0,
         y: 0,
         opacity: 1,
         transition: { type: "tween" },
      },
      exit: {
         opacity: 0,
      },
   };

   function handleCurrentStates(countryName) {
      setCurrentStates([]);
      const currentState = CountriesList.find(
         (country) => country.name.toLowerCase() === countryName.toLowerCase()
      )?.states.map((el) => ({ value: el.name.toLowerCase(), label: el.name }));
      setCurrentStates(currentState as any[]);
   }

   function handleChange(e, type: string) {
      setCurrentFilter({ ...currentFilters, [type]: e?.value });
   }

   async function handleSearch() {
      router.push({
         pathname: "/school/search",
         query: paramsObjectToQueryString(currentFilters).slice(1),
      });
   }

   useEffect(() => {
      if (school) {
         handleCurrentStates(school?.country);
      }
   }, [school]);

   const currentCountry = schoolData?.data?.data?.school?.country.toLowerCase();

   function handleTabContent() {
      let content;
      switch (currentTab) {
         default:
         case "overview":
            content = (
               <>
                  {school?.aboutUs && (
                     <div style={{ marginBlock: "30px" }}>
                        <h6>About {school?.name}</h6>
                        <div>
                           <p>{school?.aboutUs || "No data Yet"}</p>
                        </div>
                     </div>
                  )}

                  {school?.history && (
                     <div>
                        <h6>History of {school?.name}</h6>
                        <div>
                           <p>{school?.history || "No data yet"}</p>
                        </div>
                     </div>
                  )}
               </>
            );
            break;
         case "videos":
            content = (
               <div>
                  <h2 style={{ marginBottom: "3rem" }}>Video gallery of {school?.name}</h2>
                  <VideosWrapper>
                     {school?.videos?.split(",").map((url, index) => {
                        if (url.includes("youtube")) {
                           return (
                              <ReactPlayer
                                 key={`${url}--${index}`}
                                 width="100%"
                                 height="100%"
                                 url={url as string}
                                 stopOnUnmount
                              />
                           );
                        } else {
                           return null;
                        }
                     })}
                  </VideosWrapper>
               </div>
            );
            break;
         case "programmes":
            content = (
               <>
                  {school?.examsOffered?.length ? (
                     <div style={{ marginBlock: "30px" }}>
                        <h6>Examinations Prepared Students For</h6>
                        <div>
                           {school?.examsOffered?.split(",").map((elem) => (
                              <li key={elem}>{elem}</li>
                           ))}
                        </div>
                     </div>
                  ) : (
                     ""
                  )}
                  {school?.scholarships?.length ? (
                     <div style={{ marginBlock: "30px" }}>
                        <h6>Scholarships Offered</h6>
                        <div>
                           {school?.scholarships?.split(",").map((elem) => (
                              <li key={elem}>{elem}</li>
                           ))}
                        </div>
                     </div>
                  ) : (
                     ""
                  )}

                  {school?.subjects?.length ? (
                     <div style={{ marginBlock: "30px" }}>
                        <h6>School Subjects</h6>
                        {!school?.subjects
                           ? "No data yet"
                           : school?.subjects?.split(",").map((elem) => <li key={elem}>{elem}</li>)}
                     </div>
                  ) : (
                     ""
                  )}

                  {school?.extracurricularActivities?.length ? (
                     <div style={{ marginBlock: "30px" }}>
                        <h6>Extra Curricular Activities {school?.name}</h6>
                        {!school?.extracurricularActivities
                           ? "No data yet"
                           : school?.extracurricularActivities
                                ?.split(",")
                                .map((elem) => <li key={elem}>{elem}</li>)}
                     </div>
                  ) : (
                     ""
                  )}

                  {school?.pastAwards?.length ? (
                     <div style={{ marginBlock: "30px" }}>
                        <h6>School Awards</h6>
                        {!school?.pastAwards
                           ? "No data yet"
                           : school?.pastAwards
                                ?.split(",")
                                .map((elem) => <li key={elem}>{elem}</li>)}
                     </div>
                  ) : (
                     ""
                  )}

                  {school?.programs?.length ? (
                     <div style={{ marginBlock: "30px" }}>
                        <h6>School Programs</h6>
                        {!school?.programs
                           ? "No data yet"
                           : school?.programs?.split(",").map((elem) => <li key={elem}>{elem}</li>)}
                     </div>
                  ) : (
                     ""
                  )}

                  {school?.securityMeasures?.length ? (
                     <div style={{ marginBlock: "30px" }}>
                        <h6>School Security Measures</h6>
                        {!school?.securityMeasures
                           ? "No data yet"
                           : school?.securityMeasures
                                ?.split(",")
                                .map((elem) => <li key={elem}>{elem}</li>)}
                     </div>
                  ) : (
                     ""
                  )}
               </>
            );
            break;
         case "admission":
            content = (
               <>
                  {school?.admissionRequirements?.length ? (
                     <div>
                        <h6>Admission Requirements of {school?.name}</h6>
                        <div>
                           {school?.admissionRequirements?.split(",").map((elem) => (
                              <li key={elem}>{elem}</li>
                           ))}
                        </div>
                     </div>
                  ) : (
                     ""
                  )}
                  {school?.admissionList ? (
                     <div style={{ marginBlock: "30px" }}>
                        <h6>Admission List</h6>
                        <div>
                           <Link href={school?.admissionList || "#"} passHref>
                              <p>{school?.admissionList || "No data yet"}</p>
                           </Link>
                        </div>
                     </div>
                  ) : (
                     ""
                  )}

                  {school?.admissionProcedure && (
                     <div style={{ marginBlock: "30px" }}>
                        <h6>Admission Procedures of {school?.name}</h6>
                        <div>
                           <p>{school?.admissionProcedure || "No data yet"}</p>
                        </div>
                     </div>
                  )}
               </>
            );
            break;
         case "address":
            content = (
               <>
                  <h6>Contact {school?.name}</h6>
                  <div>
                     <p>{school?.address || "No Data Yet"}</p>
                  </div>
               </>
            );
            break;
      }
      return content;
   }

   function handleSchoolRegistration() {
      if (inSession) {
         open();
      } else {
         cookies.set("edusko-school-redirect", "true");
         cookies.set("edusko-school-redirect-path", router.asPath);
         localStorage.setItem("edusko-school-redirect-trigger-name", JSON.stringify(school?.name));
         router.push({
            pathname: "/signup",
            query: { from: `${router.pathname}`, slug: school.slug },
         });
      }
   }

   const schoolApply = query?.apply;
   const schoolAdmission = query?.admission;
   const schoolEnquiry = query?.enquiry;
   const schoolContact = query?.contact;
   const schoolProgrammes = query?.programmes;

   function generateSchoolString(school, apply, admission, enquiry, programmes, contact) {
      const name = _.startCase(_.upperFirst(school?.name));
      let category = _.startCase(school?.category.replace(/\_/gi, " "));
      const city = _.startCase(_.upperFirst(school?.city));
      const state = _.startCase(school?.state);
      const country = school?.country;

      if (country && country.toLowerCase() === "nigeria" && category === "High School") {
         category = "Secondary Schools";
      }

      let schoolString = `${name} - ${category} in ${city},`;

      if (apply) {
         schoolString = `Apply to ${name} in ${city} in ${state}`;
      } else if (admission) {
         schoolString = `Admission Requirements at ${name} in ${city} in ${state}`;
      } else if (enquiry) {
         schoolString = `Enquiry for ${name} in ${city} in ${state}`;
      } else if (programmes) {
         schoolString = `Curriculum at ${name} in ${city} in ${state}`;
      } else if (contact) {
         schoolString = `Contact ${name} in ${city} in ${state}`;
      }

      if (country && (country.toLowerCase() === "ghana" || country.toLowerCase() === "kenya")) {
         schoolString += `, ${state},`;
      } else {
         schoolString += ` ${state} State`;
      }

      return schoolString;
   }

   function generateSchoolDescription(school, apply, admission, enquiry, programmes, contact) {
      const name = _.startCase(_.upperFirst(school?.name));
      const city = _.startCase(_.upperFirst(school?.city));
      const state = _.startCase(school?.state);
      const aboutUs = school?.aboutUs;
      const admissionRequirements = school?.admissionRequirements;
      const examsOffered = school?.examsOffered;
      let category = _.startCase(school?.category.replace(/\_/gi, " "));
      const country = school?.country;

      let schoolDescription;

      if (country && country.toLowerCase() === "nigeria" && category === "High School") {
         category = "Secondary Schools";
      }

      if (apply) {
         schoolDescription = `Want to apply to ${name} in ${city}? Here’s how to submit your child’s application to ${name} in ${city} in ${state}`;
      } else if (admission) {
         const requirements = admissionRequirements?.split(".");
         schoolDescription = `How to gain admission into ${name} in ${city} in ${state}. ${
            requirements && requirements[0]
         }`;
      } else if (enquiry) {
         schoolDescription = `Want to make an inquiry about ${name} in ${city}? Here’s all you need to know about ${name} in ${city} in ${state}`;
      } else if (programmes) {
         const activities = examsOffered?.split(",");
         schoolDescription = `What are the extracurricular activities at ${name} in ${city}? ${
            activities && activities[0]
         }`;
      } else if (contact) {
         schoolDescription = `Here are the contacts of ${name} in ${city} in ${state}`;
      } else {
         const stripedHtml = aboutUs?.replace(/<[^>]+>/g, "");
         const pageDescriptionMeta = stripedHtml?.split(".");
         schoolDescription = `${name} is one of the top ${category} located in ${city} in ${
            country && (country.toLowerCase() === "ghana" || country.toLowerCase() === "kenya")
               ? `${state}`
               : ` ${state} State`
         } . ${pageDescriptionMeta[0]}`;
      }

      return schoolDescription;
   }

   return (
      <AppContainer
         title={generateSchoolString(
            school,
            schoolApply,
            schoolAdmission,
            schoolEnquiry,
            schoolProgrammes,
            schoolContact
         )}
         description={generateSchoolDescription(
            school,
            schoolApply,
            schoolAdmission,
            schoolEnquiry,
            schoolProgrammes,
            schoolContact
         )}
         image={school?.banner}
         slug={typeof window !== "undefined" ? window.location.href : ""}
      >
         <CustomModal visible={modalVisibility} handleClose={close}>
            <SchoolApplicationForm school={school} />
         </CustomModal>
         <CustomModal
            visible={isPaymentSuccessful}
            width="52.7rem"
            handleClose={handleCloseSuccessModal}
         >
            <div
               style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: "200px",
               }}
            >
               <div>
                  <img src="/icons/check.svg" alt="checked" />
               </div>
               <h4>Payment Made Successfully</h4>
               <p style={{ marginTop: "10px", textAlign: "center" }}>
                  Your application to {school?.name} was Successful, your payment receipt will be
                  sent to your mail
               </p>
            </div>
         </CustomModal>

         <CustomModal visible={enquiryModalVisibility} handleClose={closeEnquiryModal}>
            <SchoolEnquiryForm school={school} close={closeEnquiryModal} />
         </CustomModal>
         <NonDashboardWrapper>
            <SingleSchoolBanner
               schoolData={schoolData}
               open={open}
               openEnquiryModal={openEnquiryModal}
               school={school}
               ratings={ratings}
               likes={likes}
               views={views}
               refetch={refetch}
               slug={slug}
            />
            <NewSchoolContainer>
               <DetailsFlexDiv>
                  <div className="first-details-div">
                     <div className="slider-images-container">
                        <Carousel
                           showThumbs={false}
                           showIndicators={false}
                           infiniteLoop
                           autoPlay
                           stopOnHover
                           onChange={() => setIsPlaying(false)}
                        >
                           {school &&
                              _.union(school?.facilityImages?.split(",")).map((url) => {
                                 return (
                                    <div
                                       className="carousel-item"
                                       key={url as string}
                                       style={{ backgroundImage: `url(${url})` }}
                                    />
                                 );
                              })}
                        </Carousel>
                     </div>
                     <div className="school-details">
                        <div className="school-tab-items">
                           <button
                              onClick={() => setCurrentTab("overview")}
                              className={`${currentTab === "overview" ? "active" : ""} `}
                           >
                              Overview
                           </button>
                           <Link href={`/school/${slug}?admission=yes`} passHref>
                              <button
                                 className={`${currentTab === "admission" ? "active" : ""} `}
                                 onClick={() => setCurrentTab("admission")}
                                 onTouchStart={() => setCurrentTab("admission")}
                              >
                                 Admissions
                              </button>
                           </Link>
                           <Link href={`/school/${slug}?programmes=yes`} passHref>
                              <button
                                 className={`${currentTab === "programmes" ? "active" : ""} `}
                                 onClick={() => setCurrentTab("programmes")}
                                 onTouchStart={() => setCurrentTab("programmes")}
                              >
                                 Programmes
                              </button>
                           </Link>
                           {school?.videos?.includes("youtube") ? (
                              <button
                                 className={`${currentTab === "videos" ? "active" : ""} `}
                                 onClick={() => setCurrentTab("videos")}
                                 onTouchStart={() => setCurrentTab("videos")}
                              >
                                 Video Gallery
                              </button>
                           ) : null}
                           <Link href={`/school/${slug}?contact=yes`} passHref>
                              <button
                                 className={`${currentTab === "address" ? "active" : ""} `}
                                 onClick={() => setCurrentTab("address")}
                              >
                                 Contact
                              </button>
                           </Link>
                        </div>

                        <AnimatePresence>
                           <motion.div
                              className="brief"
                              variants={variant}
                              initial="hidden"
                              animate="show"
                              key={currentTab}
                           >
                              {handleTabContent()}
                           </motion.div>
                        </AnimatePresence>
                     </div>
                  </div>

                  <div className="second-details-div">
                     <div className="school-meta">
                        <h6 className="school-meta_name">{school?.name}</h6>
                        <div className="school-meta_div">
                           <p className="school-meta_div-label">Academic Year</p>
                           <p className="school-meta_div-text">
                              {new Date().getUTCFullYear()}/{new Date().getUTCFullYear() + 1}
                           </p>
                        </div>
                        <div className="school-meta_div">
                           <p className="school-meta_div-label">Curriculum</p>
                           <p className="school-meta_div-text">
                              {school?.curriculum
                                 ?.split(",")
                                 ?.map(
                                    (el, index) =>
                                       ` ${el.replace(/_/gi, " ")} ${
                                          index === school?.curriculum.split(",").length - 1
                                             ? "."
                                             : ","
                                       }`
                                 )}
                           </p>
                        </div>
                        <div className="school-meta_div">
                           <p className="school-meta_div-label">School Type</p>
                           <p className="school-meta_div-text">
                              {school?.type?.replace(/_/gi, " ")}
                           </p>
                        </div>
                        <div className="school-meta_div">
                           <p className="school-meta_div-label">Category</p>
                           <p className="school-meta_div-text">
                              {school?.category?.replace(/_/gi, " ")}
                           </p>
                        </div>
                        <div className="school-meta_div">
                           <p className="school-meta_div-label">Admission Fee</p>
                           <p className="school-meta_div-text green-text">
                              {Intl?.NumberFormat("en-NG", {
                                 style: "currency",
                                 currency: school?.currency || "NGN",
                              }).format(!school?.applicationFee ? 0 : school?.applicationFee)}
                           </p>
                        </div>
                        <div className="btns-div">
                           <Link href={`/school/${slug}?apply=yes`} passHref>
                              <div>
                                 <Button
                                    variant="primary"
                                    fullWidth
                                    onClick={handleSchoolRegistration}
                                    disabled={!school?.hasBank}
                                    style={{
                                       borderRadius: "8px",
                                    }}
                                 >
                                    Apply For Admission
                                 </Button>
                              </div>
                           </Link>
                           <Link href={`/school/${slug}?enquiry=yes`} passHref>
                              <div>
                                 <Button
                                    variant="secondary"
                                    fullWidth
                                    onClick={openEnquiryModal}
                                    style={{
                                       color: "#3678E5",
                                       borderColor: "#3678E5",
                                       marginTop: "12px",
                                       borderRadius: "8px",
                                    }}
                                 >
                                    Make Enquiry
                                 </Button>
                              </div>
                           </Link>
                           <div>
                              <Button
                                 variant="link"
                                 fullWidth
                                 onClick={() => router.push("/education-finance")}
                                 style={{
                                    textDecoration: "underline",
                                    marginTop: "12px",
                                    padding: "14px 24px",
                                 }}
                              >
                                 Access Tuition Finance
                              </Button>
                           </div>
                        </div>
                        <div className="call">
                           <p>
                              Call:{" "}
                              <Link
                                 href={
                                    currentCountry === "nigeria"
                                       ? `tel:09164108484`
                                       : currentCountry === "ghana"
                                       ? `tel:07052704253`
                                       : `tel:0720439203`
                                 }
                                 passHref
                              >
                                 {currentCountry === "ghana" ? (
                                    <span>+234 705 270 4253</span>
                                 ) : currentCountry === "kenya" ? (
                                    <span>+254 720 439 203</span>
                                 ) : (
                                    <span>+234 916 410 8484</span>
                                 )}
                              </Link>
                           </p>
                        </div>
                     </div>
                     <div className="school-meta" style={{ marginTop: "2rem" }}>
                        <h6 className="school-meta_title">Further search</h6>
                        <div className="school-meta_filters">
                           <SchoolFilterSelect
                              placeholder="Select State"
                              label="State"
                              labelColor="#6D7A98"
                              margin="1.6rem 0 0"
                              options={currentStates}
                              onChange={(e) => handleChange(e, "state")}
                              // key={currentStates[0]?.value}
                           />
                           {/* <SchoolFilterSelect
                              placeholder="Select"
                              label="Local Government (LGA)"
                              labelColor="#6D7A98"
                              options={CountriesList.map((c) => ({
                                 label: c.name,
                                 value: c.name.toLowerCase(),
                              }))}
                              onChange={(val: any) => {
                                 handleChange(val, "country");
                                 handleCurrentStates(val?.value);
                              }}
                           /> */}
                           <SchoolFilterSelect
                              placeholder="Select Category"
                              label="Category"
                              labelColor="#6D7A98"
                              margin="1.6rem 0 0"
                              onChange={(e) => handleChange(e, "category")}
                              options={schoolCategory}
                           />
                           <SchoolFilterSelect
                              placeholder="Select Type"
                              label="Type"
                              labelColor="#6D7A98"
                              margin="1.6rem 0 0"
                              onChange={(e) => handleChange(e, "type")}
                              options={schoolType}
                           />
                           <SchoolFilterSelect
                              placeholder="Select Range"
                              label="School Fees"
                              labelColor="#6D7A98"
                              margin="1.6rem 0 0"
                              onChange={(e) => handleChange(e, "fees")}
                              options={schoolFees}
                           />
                           <div style={{ display: "flex", justifyContent: "flex-end" }}>
                              <Button
                                 variant="primary"
                                 onClick={handleSearch}
                                 disabled={!currentFilters}
                                 style={{
                                    borderRadius: "8px",
                                    marginTop: "16px",
                                 }}
                              >
                                 Search
                              </Button>
                           </div>
                        </div>
                     </div>
                  </div>
               </DetailsFlexDiv>
               <AdvertDiv>
                  {adverts?.map((el, id) => {
                     if (id < 2) {
                        return (
                           <div key={id} className="ad-card">
                              <Link passHref href={el?.url || "#"}>
                                 <a target="_blank">
                                    <img alt="banner" src={el?.image || ""} />
                                 </a>
                              </Link>
                           </div>
                        );
                     }
                  })}
               </AdvertDiv>
               <ReviewDiv>
                  <div className="read-review">
                     <NewSchoolComments
                        schoolId={school.id}
                        commentRef={commentRef}
                        setSchoolsReviews={setSchoolsReviews}
                        schoolReviews={schoolReviews}
                     />
                  </div>
                  <div className="write-review">
                     <AddNewReview
                        schoolId={school.id}
                        commentRef={commentRef}
                        setSchoolsReviews={setSchoolsReviews}
                        name={school?.name}
                     />
                     <SchoolRatings name={school?.name} schoolId={school?.id} ratings={ratings} />
                  </div>
               </ReviewDiv>
               {sisterSchools?.length ? (
                  <div>
                     <FeaturedSchools
                        schools={sisterSchools}
                        headingText={`Sisters Schools to ${school?.name}`}
                        noPadding
                        noSeeMore
                     />
                  </div>
               ) : (
                  ""
               )}
               {similarSchools?.length ? (
                  <div>
                     <FeaturedSchools
                        schools={similarSchools}
                        headingText="Similar Schools"
                        noPadding
                        noSeeMore
                     />
                  </div>
               ) : (
                  ""
               )}
            </NewSchoolContainer>
         </NonDashboardWrapper>
      </AppContainer>
   );
};

export const getServerSideProps: GetServerSideProps = async (ctx: GetServerSidePropsContext) => {
   const slug = ctx.params?.slug;
   const { query } = ctx;
   const key = {
      queryKey: ["single-school", slug],
   };

   let singleSchoolError = false;
   let errorStatus = null;
   let errorMsg = null;

   const getSchoolApiData = async () => {
      try {
         const res: any = await getSingleSchool(key, ctx);
         return res;
      } catch (err) {
         singleSchoolError = true;
         errorStatus = (err as any).response?.status;
         errorMsg = (err as any).response?.data?.message;
      }
   };

   const schoolResponse: any = await getSchoolApiData();
   const advertsResponse = await fetchAllRankedAds();

   console.log(errorMsg);

   return {
      props: {
         schoolData: schoolResponse || null,
         adverts: advertsResponse.data.data || null,
         slug,
         error: singleSchoolError,
         errorStatus,
         errorMsg,
         query,
      },
   };
};

export default SingleSchool;
